import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

const getLaborTicketAction = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.laborTicketAction;
  }
);

export { getLaborTicketAction };
